import React from 'react'

import { Form, Input, Spin, Typography, Tooltip } from 'antd'

import i18n from 'i18n'
import classNames from 'classnames'
import feather from 'feather-icons'

import PerfectScrollbar from 'libs/react-perfect-scrollbar'
import FeatherIcon from 'components/FeatherIcon'

import search24SVG from '@/assets/images/toolbar-search-24.svg'
import iconClear20SVG from '@/assets/images/icon-clear-20.svg'

import styles from './style.module.scss'

const { Link } = Typography
const { Search } = Input

class SelectFeatherIcon extends React.Component {
  state = {
    loading: false,
    iconElems: [],
    // showTooltip: false,
  }

  formRef = React.createRef()

  scrollRef = React.createRef()

  searchText = null

  iconNameList = []

  tooltipTimerMap = {}

  componentDidMount() {
    // console.log(' ---- feather : ', feather.icons);
    this.initData()
  }

  // componentDidUpdate(prevProps) {
  // }

  componentWillUnmount() {}

  initData = () => {
    this.setState({
      loading: true,
    })

    setTimeout(() => {
      this.iconNameList = this.getIconNameList()

      this.filteredIconNameList = this.iconNameList

      const iconElems = this.getIconElems()

      this.setState({
        loading: false,
        iconElems,
      })
    }, 100)
  }

  getIconNameList = () => {
    const iconNames = Object.keys(feather.icons)
    return iconNames
  }

  getFilteredIconNameList = (searchText) => {
    const filteredIconNameList = this.iconNameList.filter((iconName) => {
      return searchText == null || iconName.includes(searchText)
    })

    return filteredIconNameList
  }

  onSearch = (value) => {
    console.log('onSearch - ', value)
    if (value != null && value.length > 0) {
      this.searchText = value.toLowerCase()
    } else {
      this.searchText = null
    }

    this.filteredIconNameList = this.getFilteredIconNameList(this.searchText)

    const iconElems = this.getIconElems()

    this.setState({
      iconElems,
    })
  }

  onChange = (e) => {
    console.log('onChange - ', e)
    const { value } = e.target
    if (this.searchTimer != null) {
      clearTimeout(this.searchTimer)
    }

    this.searchTimer = setTimeout(() => {
      this.searchTimer = null
      this.onSearch(value)
    }, 300)
  }

  onClickIcon = (name) => {
    const { onIconSelected } = this.props
    console.log('onClickIcon - ', name)

    if (onIconSelected != null) {
      onIconSelected(name)
    }
  }

  getIconElems = () => {
    const iconRows = []
    const self = this

    this.filteredIconNameList.forEach((iconName, index) => {
      const rowNum = Math.floor(index / 9)
      const columnNum = index % 9
      while (rowNum >= iconRows.length) {
        iconRows.push([])
      }
      const row = iconRows[rowNum]
      while (columnNum >= row.length) {
        row.push(null)
      }
      row[columnNum] = iconName
    })

    const iconElems = iconRows.map((row, idx) => {
      const rowElems = row.map((iconName) => {
        const iconAttrs = {
          name: iconName,
          width: '24',
          height: '24',
          stroke: '#3362FF',
        }

        const linkAttrs = {
          className: classNames(styles.FeatherIconItem),
          onClick: () => {
            this.onClickIcon(iconName)
          },
        }

        const TooltipItem = () => {
          const [open, setOpen] = React.useState(false)

          return (
            <Tooltip
              title={iconName}
              key={iconName}
              overlayClassName={classNames(styles.tooltipInner)}
              open={open}
              onOpenChange={(visible) => {
                console.log('onOpenChange - ', visible)
                setOpen(visible)

                if (visible) {
                  self.tooltipTimerMap[iconName] = setTimeout(() => {
                    setOpen(false)
                  }, 1000)
                } else {
                  clearTimeout(self.tooltipTimerMap[iconName])
                }
              }}
            >
              <Link {...linkAttrs}>
                <div className={classNames(styles.iconWrapper)}>
                  <FeatherIcon {...iconAttrs} />
                </div>
              </Link>
            </Tooltip>
          )
        }

        return <TooltipItem />
      })

      const key = `row_${idx}`

      return (
        <div key={key} className={classNames(styles.FeatherIconRow)}>
          {rowElems}
        </div>
      )
    })

    if (this.scrollRef.current != null) {
      this.scrollRef.current.element.scrollTop = 0
      this.scrollRef.current.update()
    }

    return iconElems
  }

  render() {
    const { loading, iconElems } = this.state
    // const { } = this.props;

    const searchAttrs = {
      ref: this.searchRef,
      placeholder: i18n.t('workspace.search.placeholder'),
      onSearch: this.onSearch,
      prefix: <img src={search24SVG} alt="search" />,
      allowClear: { clearIcon: <img src={iconClear20SVG} alt="clear" /> },
      onChange: this.onChange,
    }

    return (
      <div className={classNames(styles.selectFeatherIcon, 'selectFeatherIcon')}>
        <Form component={false} ref={this.formRef}>
          <Form.Item name="val" noStyle>
            <Search {...searchAttrs} />
          </Form.Item>
        </Form>
        <Spin spinning={loading}>
          <PerfectScrollbar className={classNames(styles.featherIcons)} refScroll={this.scrollRef}>
            {iconElems}
          </PerfectScrollbar>
        </Spin>
      </div>
    )
  }
}

export default SelectFeatherIcon
